export default {
  host: "https://member.tahleegold.com:3000/api"
  // host: "http://localhost:3001/api"
};
